import {useEffect, useState} from 'react';

import {getClientCity} from 'ultra/configs/general';

import {getFilter} from '../../../../Helpers/filters';
import ContentImage from '../../../../Modules/Content/Widgets/ContentImage';

export default function FilterValue(props) {
    const {value, config, filters} = props;

    const city = getClientCity(window);
    const [filter, setFilter] = useState();

    useEffect(() => {
        let currentFilter = {}
        if (config?.source) {
            if (config.source === "city:chats") {
                currentFilter = filters

                setFilter(<div className='SelectedFilterValue'>
                    <ContentImage image={currentFilter?.images?.[value]} city={city} className='icon'/>
                    {currentFilter?.values?.[value]}
                </div>);
            }
            else {
                currentFilter = getFilter(filters, city, config?.source);

                if (currentFilter?.images) {
                    setFilter(<div className='SelectedFilterValue'>
                        <ContentImage image={currentFilter?.images?.[value]} city={city} className='icon'/>
                        {currentFilter?.values?.[value]}
                    </div>);
                }
                else {
                    setFilter(currentFilter?.values?.[value]);
                }
            }            
        }
        else if (config?.values?.values) {
            currentFilter.values = config.values.values;
            
            if (currentFilter?.images) {
                setFilter(<div className='SelectedFilterValue'>
                    <ContentImage image={currentFilter?.images?.[value]} city={city} className='icon'/>
                    {currentFilter?.values?.[value]}
                </div>);
            }
            else {
                setFilter(currentFilter?.values?.[value]);
            }
        }
    }, [value, config, filters])


    if (!filter) return <></>

    return filter
}
